export default "__VITE_ASSET__570ed967__"